<template>
  <v-dialog v-model="dialog" persistent max-width="750px">
    <v-card>
      <v-toolbar color="#313a46">
        <v-card-title class="text-h5 white--text">>Grupo: {{ nameGroup }} </v-card-title>
        <v-spacer></v-spacer>
        <v-btn color="error" @click="closeModal()" icon>
          <v-icon>mdi-close-circle</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-container>
          <v-form ref="formGroups">
            <v-row class="mt-4">
              <v-col cols="12" class="pa-0">
                <v-combobox
                  :loading="loadingLabel"
                  v-model="selectedCollaborator"
                  :items="colaboradoresList"
                  chips
                  clearable
                  label="Colaboradores"
                  multiple
                  prepend-icon="mdi-account"
                  solo
                >
                  <template
                    v-slot:selection="{ attrs, item, select, selected }"
                  >
                    <v-chip
                      color="primary"
                      v-model="selectedCollaborator"
                      v-bind="attrs"
                      :input-value="selected"
                      close
                      @click="select"
                      @click:close="remove(item)"
                    >
                      <strong>{{ item.text }}</strong>
                    </v-chip>
                  </template>
                </v-combobox>
              </v-col>
            </v-row>
            <v-row class="ma-0">
              <v-col cols="12" class="pa-0 new-emails" v-for="(item, index) in emailsExternos" :key="index">
                <v-row class="ma-0">
                  <v-col cols="12" sm="6" class="pa-0 pr-sm-1">
                    <v-text-field label="Nome" v-model="emailsExternos[index].nome" :rules="[rules.required]"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" class="pa-0 pl-sm-1">
                    <v-text-field label="Email externo" v-model="emailsExternos[index].email" :rules="[rules.required, rules.email]"></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row class="ma-0">
              <v-col cols="12" class="pa-0 d-flex">
                <v-btn
                  class="pa-0"
                  color="#313a46"
                  plain
                  @click="addEmailExterno()"
                >
                  <v-icon left>mdi-plus</v-icon>
                  Adicionar Email externo
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn
                  v-if="emailsExternos.length > 0"
                  width="100"
                  class="pa-0 white--text"
                  color="success"
                  @click="createdExternalEmails()"
                >
                  Salvar
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import toast from "@/commom/toast.js";
// import colaboradores from "@/services/http/organizacao/colaboradores";
import gruposEmail from "@/services/http/rpa/GruposEmail";
import contatoEmail from "@/services/http/rpa/ContatoEmail";
import emailExterno from "@/services/http/rpa/EmailExterno";
export default {
  props: {
    nameGroup: {
      type: String,
    },
    dialog: {
      type: Boolean,
      default: false,
    },
    selectedItem: {},
  },
  data: () => ({
    loadingLabel: true,
    colaboradoresList: [],
    selectedCollaborator: [],
    lastList: [],
    itensFormContributors: {
      colaborador_id: "",
    },
    rules: {
      required: (value) => !!value || "Campo obrigatório.",
      email: (value) => {
        const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return pattern.test(value) || "E-mail inválido.";
      },
    },
    emailsExternos: [],
  }),
  async created() {
    this.fetchContributors();
  },
  methods: {
    closeModal() {
      this.emailsExternos = [];
      this.$emit("update:dialog", false);
    },
    async add(item) {
      await gruposEmail(this.selectedItem.id)
        .colaboradoresStore({
          colaborador_id: item.value,
        })
        .then(() => toast("success", "Colaborador adicionado"))
        .catch((err) => {
          toast("error", "Erro inesperado");
        });
      this.get(this.selectedItem.id);
    },
    async remove(item) {
      this.selectedCollaborator = [...this.selectedCollaborator];
      try {
        await gruposEmail(this.selectedItem.id).colaboradoresDelete(
          `/${item.value}`
        );
        toast("success", "Colaborador removido");
        this.selectedCollaborator.splice(
          this.selectedCollaborator.indexOf(item),
          1
        );
      } catch (err) {
        toast("error", "Erro inesperado");
        console.log(err);
      }
    },
    async get(id) {
      this.loadingLabel = true;
      let res = await gruposEmail().show({
        id: id,
        includes: 'contatosEmail'
      });
      res = res.data.data;
      this.lastList = res[0].contatos_email.length;
      var results = res[0].contatos_email.map((item) => {
          return {
            value: item.id,
            text: item.nome,
          };
        })
      this.loadingLabel = false;
      this.selectedCollaborator = results;
    },

    async fetchContributors() {
      let { data } = await contatoEmail().show({ per_page: -1 });
      this.colaboradoresList = data.data.map((index) => {
        return {
          value: index.id,
          text: `${index.id} - ${index.nome}`,
        };
      });
    },
    addEmailExterno() {
      this.emailsExternos.push({ nome: "", email: "" });
    },

    async createdExternalEmails() {
      if (this.$refs.formGroups.validate()) {
        try {
          await Promise.all(
            this.emailsExternos.map(async (item) => {
              let res = await emailExterno().store(item);
              item.email_id = res.data.email_id;
            })
          );
          toast("success", "Emails externos adicionados com sucesso");
          this.emailsExternos = [];
        } catch (err) {
          console.error(err);
          toast("error", "Erro inesperado ao adicionar emails externos");
        }finally{
          this.fetchContributors()
        }
      }
    },
  },
  watch: {
    async selectedItem(item) {
      await this.get(item.id);
    },
    async selectedCollaborator(item) {
      if (item.length > this.lastList) this.add(item[item.length - 1]);
    },
  },
};
</script>
<style scoped>
.chipsCustom {
  background-color: #ffff !important;
}
</style>
